import {HttpParameterCodec, HttpInterceptor, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

export class XWwwUrlEncodedParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

@Injectable()
export class EncodeHttpParamsInterceptor implements HttpInterceptor {
  intercept(req, next) {
    const params = new HttpParams({encoder: new XWwwUrlEncodedParamEncoder(), fromString: req.params.toString()});
    return next.handle(
      req.clone({
        params,
        url: req.url
      })
    );
  }
}
